import { DateUtility } from '@alpha-coach-bot/shared-util';
import {isBefore, isDate, isValid, min, parseISO} from 'date-fns';
import {JsonProperty} from 'json-object-mapper';
import {Week} from './week.model';

export class Session {
  @JsonProperty() public id: string;
  @JsonProperty() public label: string;
  @JsonProperty() public name: string;
  @JsonProperty() public schoolYear: string;

  @JsonProperty({name: 'end'}) public endISODate: string;
  @JsonProperty({name: 'isCurrent'}) public current: boolean;
  @JsonProperty({name: 'start'}) public startISODate: string;

  public constructor() {
    this.current      = false;
    this.endISODate   = null;
    this.id           = '';
    this.label        = '';
    this.name         = '';
    this.schoolYear   = '';
    this.startISODate = null;
  }

  public get end(): Date {
    const date = parseISO(this.endISODate);
    return isValid(date) ? date : null;
  }

  public get labelShort(): string {
    const [fragment] = this.label.split(',');
    return fragment;
  }

  public get start(): Date {
    const date = parseISO(this.startISODate);
    return isValid(date) ? date : null;
  }

  public get weeks(): Week[] {
		return this.generateWeeksDate(false);
  }

	public get isoWeeks(): Week[] {
		return this.generateWeeksDate(true);
	}

	private generateWeeksDate(isISO: boolean) {
		const {start, end} = this;

		if(!isDate(start) || !isDate(end)) {
			return null;
		}

		const weeks: Week[] = [];
		let pointer         = new Date(start);
		let name            = 1;

		while(isBefore(pointer, end)) {
			const week = new Week();
			week.name  = `${name}`;
			week.start = new Date(pointer);
			name       = name + 1;
			pointer    = isISO ? DateUtility.nextMonday(pointer) : DateUtility.nextSaturday(pointer);
			week.end   = min([pointer, end]);
			weeks.push(week);
		}

		return weeks;
	}
}
